import React, { forwardRef, useEffect, useState } from 'react'

//partials
import Objects from './Objects'
import { useFieldsContext } from '../../../../../../../contexts/FieldsContext';

import editIcon from '../../../../../../../assets/img/pages/icons/edit-field.jpg'
import SignPanel from '../../../../../../partials/SignPanel';

function Fields(props) {
    const fieldsContext = useFieldsContext();

    const editable = props.editable || false;
    const original = props.original;
    const data = props.data;

    const fieldsData = {
        openingorder: {},
    }

    const [fields, setFields] = useState(fieldsData)

    useEffect(() => {
        if (original) {
            setFields(original)
        }
    }, [original])

    const handleFieldChange = e => {

        let isObj = Boolean(e.target.name.includes('['))
        let name = e.target.name
        let val = e.target.value

        if (isObj) {
            let nameFirstPart = name.split('[')[0]
            let nameSecondPart = name.split('[')[1].split(']')[0]

            setFields(prev => ({
                ...prev,
                [nameFirstPart]: {
                    ...prev[nameFirstPart],
                    [nameSecondPart]: val,
                }
            }))
        } else {
            setFields(prev => ({
                ...prev,
                [name]: val
            }))
        }

    }

    const handleDateChange = e => {
        let val = e.target.value;
        let name = e.target.name
        let nameFirstPart = name.split('[')[0]

        setFields(prev => ({
            ...prev,
            [nameFirstPart]: {
                ...prev[nameFirstPart],
                date_formatted: val
            }
        }));
    }

    return (
        <div className="panel">
            <div className="row">
                <div className="col col-auto">
                    <h3>
                        <span>
                            1
                            </span>
                            Дата и №
                    </h3>
                    <div className="holder">
                        <div className="row">
                            <div className="col able-to-edit">
                                <label htmlFor="order_no">
                                    № заповед
                                </label>
                                {fields && ((fields.openingorder && fields.openingorder.no) || fields.opening_order_gno) && <img
                                    src={editIcon}
                                    alt="edit"
                                    className="edit"
                                    onClick={e => fieldsContext.handleEdit(e)}
                                />}
                                <input autoComplete="off" role="presentation"
                                    id="openingorder"
                                    name="openingorder[no]"
                                    type="text"
                                    placeholder="Въведете №"
                                    className="field-medium"
                                    value={fields && fields.openingorder ? fields.openingorder.no : fields.opening_order_gno}
                                    readOnly={fields && ((fields.openingorder && fields.openingorder.no) || fields.opening_order_gno) ? true : false}
                                    onChange={handleFieldChange}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col able-to-edit">
                                <label htmlFor="openingorder">
                                    Дата
                                </label>
                                {fields && fields.openingorder && fields.openingorder.date && <img
                                    src={editIcon}
                                    alt="edit"
                                    className="edit"
                                    onClick={e => fieldsContext.handleEdit(e)}
                                />}
                                <input autoComplete="off" role="presentation"
                                    id="openingorder_date"
                                    name="openingorder[date]"
                                    type="date"
                                    value={fields && fields.openingorder && fields.openingorder.date_formatted ? fields.openingorder.date_formatted : fieldsContext.today()}
                                    readOnly={fields && fields.openingorder && fields.openingorder.date ? true : false}
                                    onChange={handleDateChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col">
                    <Objects
                        procedure_id={fields.id}
                    />
                </div>

                <div className="col">
                    <SignPanel
                        panelName="openingorder_commission"
                        mayor={fields.openingorder && fields.openingorder.mayorsignature}
                        mayorInput="openingorder[signed_by]"
                        mayorReason={fields.openingorder && fields.openingorder.signed_by_reason}
                        agreed={fields.openingorder && fields.openingorder.commission_text}
                        agreedInput="openingorder[commission]"
                        prepared={fields.openingorder && fields.openingorder.preparedsignature}
                        preparedInput="openingorder[prepared_by]"
                        handleModify={props.handleModify}
                    />
                </div>
            </div>
        </div>
    )
}

export default React.memo(Fields, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
});